import ShiftDeclinedReason from "@/models/Shared/ShiftDeclinedReason";
import IShift from "@/models/Shifts/IShift";

export default class AnonBookedReplyViewModel implements IShift {
    bookingRoleWorkerShiftId = '';
    startAt: Date;
    endAt: Date;
	confirm = false;
	declinedReason: ShiftDeclinedReason;
}